import { render, staticRenderFns } from "./ReportConfirm.vue?vue&type=template&id=bcbfb538&"
import script from "./ReportConfirm.vue?vue&type=script&lang=js&"
export * from "./ReportConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ReportConfirm.vue?vue&type=style&index=0&id=bcbfb538&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports